import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedCargoType } from 'contracts/CargoTypes';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_CARGO_TYPES_',
  }
);

export interface ListCargoTypesState {
  data: ListedCargoType[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListCargoTypesRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedCargoType[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListCargoTypesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListCargoTypesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListCargoTypesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListCargoTypesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListCargoTypesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listCargoTypes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListCargoTypesTypes = Types;
export const ListCargoTypesActions = Creators;
